import { useTranslation } from "react-i18next";
import { Box, Button, Divider, Typography } from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { getAllServicesRoute } from "../../../../../../routers/routeUtils";

import { ButtonArrowRightIcon, GoServiceTitleIcon } from "../../../../assets/icons/go-service-icons";

import { UserServicesResponse } from "../../../../../GoService/api/types/userService.types";

import ServicesList from "./ServicesList";

const MyOfferedServices = ({
  fullName,
  entityUserId,
  isOwn,
  isDataLoading,
  servicesData,
}: {
  fullName: string;
  entityUserId?: string;
  isOwn?: boolean;
  isDataLoading?: boolean;
  servicesData?: UserServicesResponse;
}) => {
  const { t, i18n } = useTranslation("profiles", {
    keyPrefix: "goService",
  });

  const navigate = useNavigate();
  const location = useLocation();

  const { userId, entityId } = useParams();
  const id = userId || entityUserId || "";

  const persona = location.pathname.split("/")[1];
  const ALL_REVIEWS_ROUTE = getAllServicesRoute(persona, id, entityId);

  const hasNoServices = (!isDataLoading && !servicesData) || (!isDataLoading && servicesData?.items.length === 0);

  return (
    <Box sx={styles.container} component="section">
      <Box sx={styles.titleContainer}>
        <Typography sx={styles.title}>
          <GoServiceTitleIcon />
          {t("myOfferedServices")}
        </Typography>
        {!hasNoServices && (
          <Button
            variant="text-md"
            endIcon={<ButtonArrowRightIcon />}
            sx={styles.seeAllServicesButton}
            onClick={() => navigate(ALL_REVIEWS_ROUTE)}
          >
            {t("seeAllServices")}
          </Button>
        )}
      </Box>
      <Divider sx={styles.divider} orientation="horizontal" />
      <ServicesList
        fullName={fullName}
        entityUserId={entityUserId}
        isOwn={isOwn}
        isDataLoading={isDataLoading}
        servicesData={servicesData}
      />
    </Box>
  );
};

export default MyOfferedServices;

const styles = {
  container: {
    padding: "20px 24px",
    borderRadius: "8px",
    border: "1px solid #EAECF0",
    background: "var(--White, #FFF)",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
  titleContainer: {
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    alignItems: { xs: "flex-start", sm: "center" },
    gap: { xs: "8px", sm: "0" },
    justifyContent: "space-between",
  },
  title: {
    color: "var(--black-100, #1C1C1C)",
    fontFamily: "Montserrat",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "28px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  seeAllServicesButton: {
    padding: "0",
    background: "transparent !important",
  },
  divider: { borderColor: "#EAECF0", margin: "0 -24px" },
};
